import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router";
import AuthTab from "../components/SharedComponent/nav/AuthTab";
import SettingsAuthTab from "../components/SharedComponent/nav/SettingsAuthTab";
import { stopArchivedAutoRefresh } from "../redux/JobModule/ArchivedPage/ArchivedAction";
import { stopNewCompletedAutoRefresh } from "../redux/JobModule/CompletedPage/NewCompletedAction";
import { stopInProgressAutoRefresh } from "../redux/JobModule/InProgressPage/InProgressAction";
import { useAppDispatch } from "../redux/useAppDispatch";

function SettingsAuthpackLayout() {
  const dispatch = useAppDispatch();
  const user = JSON.parse(JSON.parse(JSON.stringify(localStorage.getItem("userData")))).idToken.payload;
  const isAdmin = user["cognito:groups"].includes("engage-transcription-admins");

  useEffect(() => {
    return () => {
      dispatch(stopArchivedAutoRefresh());
      dispatch(stopNewCompletedAutoRefresh());
      dispatch(stopInProgressAutoRefresh());
    };
  }, []);

  if (!isAdmin) {
    return <Navigate to="/auth/access-denied" />;
  }
  return (
    <div className="app">
      <SettingsAuthTab />
      <Outlet />
    </div>
  );
}

export default SettingsAuthpackLayout;
